// extracted by mini-css-extract-plugin
module.exports = {"project-data-table":"data-table_project-data-table__9_7Id"};